import React from 'react';
import { IoChevronForward } from 'react-icons/io5';
import { Transaction } from "../../../models/User";
import { formatCurrency } from "../../../helpers/functions.tsx";
import { formatAdminFiguresDateTime as formatFiguresDateTime } from "../../../helpers/adminFiguresTime.tsx";

type Props = {
    tx: Transaction;
    betType?: string;
};

const BET_TYPE_LABELS: Record<string, string> = {
    straight: "Straight",
    parlay: "Parlay",
    teaser: "Teaser",
    contest: "Contest",
    live: "Live",
};

const TX_TYPE_LABELS: Record<string, string> = {
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    CreditAdjustment: "Credit",
    DebitAdjustment: "Debit",
    refund: "Refund",
    zeroOut: "Adjustment",
};

const sideLabel = (tx: Transaction, betType?: string) => {
    const fromBet = (betType || "").trim().toLowerCase();
    if (fromBet && BET_TYPE_LABELS[fromBet]) return BET_TYPE_LABELS[fromBet];
    if ((betType || "").trim()) return betType!.trim();
    return TX_TYPE_LABELS[tx.transactionType] || "";
};

const UpdateBetsComponent = ({ tx, betType }: Props) => {
    const formattedDate = formatFiguresDateTime(tx.createDate.toDate(), {
        month: "short",
        day: "numeric",
        year: undefined,
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });

    const isLost = tx.description === "Wager Lost";
    const isWon = tx.description === "Wager Won";
    const isNegative = isLost || tx.description === "Zero balance debit" || tx.transactionType === "withdrawal" || tx.transactionType === "DebitAdjustment";
    const isPositive = isWon || tx.description === "Zero balance credit" || tx.transactionType === "deposit" || tx.transactionType === "CreditAdjustment";

    const amountSign = isNegative ? "-" : "";
    const ticket = tx.ticket != null ? String(tx.ticket).trim() : "";
    const typeLabel = sideLabel(tx, betType);
    const statusClass = isWon ? " tx-card__status--won" : isLost ? " tx-card__status--lost" : "";
    const amountClass = isNegative ? " is-negative" : isPositive ? " is-positive" : "";

    return (
        <article className={`tx-card${isWon ? " tx-card--won" : ""}`}>
            <div className="tx-card__main">
                <span className={`tx-card__status${statusClass}`}>{tx.description}</span>
                <span className="tx-card__date">{formattedDate}</span>
                {ticket ? <span className="tx-card__ticket">Ticket {ticket}</span> : null}
            </div>
            <div className="tx-card__side">
                {typeLabel ? (
                    <span className="tx-card__type">
                        {typeLabel}
                        <IoChevronForward className="tx-card__chevron" aria-hidden="true" />
                    </span>
                ) : null}
                <span className={`tx-card__amount${amountClass}`}>
                    {amountSign}${formatCurrency(Math.abs(tx.amount), 0)}
                </span>
            </div>
        </article>
    );
};

export default UpdateBetsComponent;
